export default __webpack_public_path__ + "static/art-context-graph-OL2-9cd41a3f174c5c9bef001f1e85a0417f.svg";